import * as React from 'react';
type Props = {
  className?: string;
};
export function PlantBasedEgg({ className }: Props) {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Plant-based egg"
      className={className}
    >
      <path
        d="M22.6294 21.792C23.1813 17.7314 24.9243 13.7743 27.572 11.547C33.3147 6.71626 38.485 12.974 40.2374 18.6964C41.9585 24.3221 41.2108 32.3194 36.1533 35.6662C32.8051 37.8817 29.5539 37.7489 26.3996 35.2678M36.7186 22.5327C36.0717 17.3651 32.3514 14.5853 32.3514 14.5853M17.7806 31.9457V36.2822M17.9508 31.8561C22.3431 32.1188 22.125 27.7187 22.125 27.7187C17.7257 27.6787 17.9508 31.8561 17.9508 31.8561ZM11.8873 25.5004C11.8873 25.5004 11.2447 32.0258 17.7946 31.9586C17.7946 31.9586 18.4302 25.7643 11.8873 25.5004ZM17.2196 40.3571C22.7851 40.3571 27.2963 35.8003 27.2963 30.1786C27.2963 27.211 26.039 24.5403 24.0342 22.6789C22.2404 21.0155 19.8472 20 17.2196 20C11.6552 20 7.14288 24.5568 7.14288 30.1786C7.14288 35.8003 11.6552 40.3571 17.2196 40.3571Z"
        stroke="currentColor"
      />
    </svg>
  );
}
